(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorkflowEditCtrl', WorkflowEditCtrl);

    WorkflowEditCtrl.$inject = [
        '$scope',
        '$routeParams',
        '$q',
        '$location',
        'WorkflowService',
        'DialogService',
        'LastUpdatedService',
        'NavigationAidService',
        'WorkflowRunService',
        'UnsavedChangesService',
        'ChilliUserProfileService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    function WorkflowEditCtrl(
        $scope,
        $routeParams,
        $q,
        $location,
        WorkflowService,
        DialogService,
        LastUpdatedService,
        NavigationAidService,
        WorkflowRunService,
        UnsavedChangesService,
        ChilliUserProfileService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.workflowDefinition = null;
        vm.selectedStep = null;
        vm.workflowApi = {};
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        vm.saveWorkflowDefinition = saveWorkflowDefinition;
        vm.deleteWorkflow = deleteWorkflow;
        vm.runWorkflow = runWorkflow;
        vm.viewWorkflowHistory = viewWorkflowHistory;
        vm.getDefinitionIncludingSteps = getDefinitionIncludingSteps;
        vm.copyWorkflow = copyWorkflow;
        vm.close = close;
        Object.defineProperty(vm, 'workflowIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        vm.viewTitle = '';
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getLabel(vm.workflowDefinition); }
        });

        activate();

        function activate() {
            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadWorkflowDefinition,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    updateViewTitle();
                }
            });
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = '';

            if (vm.workflowIsNew) {
                title = 'Add Workflow';
            } else {
                title = 'Workflow' + ((!_.isNil(vm.workflowDefinition) && !_.isNil(vm.workflowDefinition.Name) && vm.workflowDefinition.Name !== '') ? ' - ' + vm.workflowDefinition.Name : '');
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        function loadWorkflowDefinition() {
            var loadPromise;

            if (!vm.workflowIsNew) {
                loadPromise = WorkflowService.get($routeParams.id);
            } else if ($routeParams.copyWorkflowId) {
                loadPromise = WorkflowService.getCopy($routeParams.copyWorkflowId);
            } else {
                loadPromise = $q.when(newWorkflowDefinition());
            }

            return loadPromise.then(getWorkflowOk, getWorkflowError);

            function getWorkflowOk(workflow) {
                vm.workflowDefinition = workflow;
                vm.workflowApi.setStepsAndGraphData(workflow.Steps, workflow.Diagram);

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.getDefinitionIncludingSteps()',
                    saveFunction: saveWorkflowDefinition,
                    unsavedItemName: 'Workflow'
                });
            }

            function getWorkflowError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Workflow definition', response);
                }
            }
        }

        function newWorkflowDefinition() {
            return {
                Name: '',
                Steps: [
                    {
                        'StepId': '',
                        'Drawing': {
                            'X': 100,
                            'Y': 50
                        },
                        'StepType': 'Start',
                        'Name': 'Start',
                        'Properties': {}
                    },
                    {
                        'StepId': '',
                        'Drawing': {
                            'X': 400,
                            'Y': 50
                        },
                        'StepType': 'End',
                        'Name': 'End',
                        'Properties': {}
                    }
                ],
                Diagram: '',
                Active: true
            };
        }

        function getDefinitionIncludingSteps() {
            var defCopy = angular.copy(vm.workflowDefinition);
            defCopy.Steps = vm.workflowApi.getSteps();
            return defCopy;
        }

        function saveWorkflowDefinition() {
            vm.workflowDefinition.Steps = vm.workflowApi.getSteps();

            return WorkflowService.save(vm.workflowDefinition)
                .then(saveOk, saveError);

            function saveOk(response) {
                if (vm.workflowIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('workflow/' + response);
                } else {
                    vm.workflowDefinition = response;
                    vm.workflowApi.setStepsAndGraphData(response.Steps, response.Diagram);

                    vm.editWorkflowForm.$setPristine();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.getDefinitionIncludingSteps()',
                        saveFunction: saveWorkflowDefinition,
                        unsavedItemName: 'Workflow'
                    });

                    updateViewTitle();
                }
            }

            function saveError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.workflowDefinition,
                    'Workflow definition',
                    vm.saveWorkflowDefinition,
                    function () {
                        return WorkflowService.get($routeParams.id);
                    });
            }
        }

        /**
         * Delete the workflow.
         */
        function deleteWorkflow() {
            if (!vm.workflowIsNew) {
                DialogService.confirm('Delete the Workflow?', 'Workflow delete confirm')
                    .then(deleteOk);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteOk() {
                WorkflowService.remove(vm.workflowDefinition.Id)
                    .then(deleteWorkflowOk, deleteWorkflowError);

                function deleteWorkflowOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteWorkflowError(response) {
                    DialogService.error('Error deleting Workflow', response);
                }
            }
        }

        function runWorkflow() {
            if (!vm.workflowIsNew) {
                WorkflowRunService.createInstance(vm.workflowDefinition.Id)
                    .then(createWorkflowOk, createWorkflowError);
            } else {
                promptUserToSaveForOperation('running');
            }

            function createWorkflowOk(instanceId) {
                $location.path('/runworkflow/' + instanceId);
            }

            function createWorkflowError(response) {
                DialogService.error('Error starting Workflow', response);
            }
        }

        /**
         * Redirect to the workflow history route for the current workflow.
         */
        function viewWorkflowHistory() {   
            if (!vm.workflowIsNew) {
                $location.path('/workflow/' + vm.workflowDefinition.Id + '/history');
            } else {
                promptUserToSaveForOperation('viewing history');
            }
        }

        /**
         * Redirects the user to a view with a copy of the current workflow.
         */
        function copyWorkflow() {
            if (vm.workflowIsNew) {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Workflow')
                        .then(function () {
                            saveWorkflowDefinition().then(function () {
                                $location.url('workflow/new?copyWorkflowId=' + vm.workflowDefinition.Id);
                            });
                        });
                } else {
                    $location.url('workflow/new?copyWorkflowId=' + vm.workflowDefinition.Id);
                }
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /*
         * When conducting an operation which requires a saved workflow and the workflow is new, a 'save workflow' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: 'workflow', operation: operationName }
            })
            .then(function () {
                return saveWorkflowDefinition();
            });
        }
    }
})();